/* eslint-disable class-methods-use-this */
// https://jira.sephora.com/browse/UA-1872
const SEPHORA_GRAPHQL_API_ENDPOINT = Sephora.configurationSettings.gqlAPIEndpoint;
const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

const shouldRetry = (response, attempt, maxRetries) => {
    if (attempt >= maxRetries) {
        return false;
    }

    // Retry on server errors (5xx) or no response
    return !response || (response.status >= 500 && response.status < 600);
};

class FetchMiddleware {
    async request(context, _next) {
        const MAX_RETRIES = context.options?.maxRetries ?? 3;
        const RETRY_DELAY = context.options?.retryDelay ?? 2000;

        const options = {
            method: 'POST',
            headers: context.headers,
            body: JSON.stringify(context.body)
        };

        const executeAttempt = async (attempt = 0) => {
            try {
                const response = await window.fetch(SEPHORA_GRAPHQL_API_ENDPOINT, options);

                // Check if we should retry based on response status
                if (shouldRetry(response, attempt, MAX_RETRIES)) {
                    await delay(RETRY_DELAY);

                    return executeAttempt(attempt + 1);
                }

                // If successful or we shouldn't retry, parse and return
                const responseData = await response.json();

                return responseData;
            } catch (error) {
                // Retry on network errors (fetch throws on network failure)
                if (attempt < MAX_RETRIES) {
                    await delay(RETRY_DELAY);

                    return executeAttempt(attempt + 1);
                }

                // If we've exhausted all retries, throw the last error
                throw error;
            }
        };

        return executeAttempt();
    }
}

export default FetchMiddleware;
